export const localeLabel = (tag) => {
	try {
		const name = new Intl.DisplayNames([tag], { type: "language" }).of(tag);
		return name && name !== tag ? `${name} (${tag})` : tag;
	} catch {
		return tag;
	}
};
